import { Guid, Nillable, valueOrDefault } from '@web/utils';
import { BoxQuestionnaireQuestionOptionAttribute } from './box-questionnaire-question-option-attribute';

export class BoxQuestionnaireQuestionOption {
  public constructor(
    private readonly data: {
      id: Guid;
      imageAlt?: Nillable<string>;
      imageUrl?: Nillable<string>;
      isAvailable: boolean;
      isSelected: boolean;
      isAutoSelected?: Nillable<boolean>;
      availableQuantity?: Nillable<number>;
      remainingQuantity?: Nillable<number>;
      name: string;
      sourceId?: Nillable<Guid>;
      sourceName?: Nillable<string>;
      attributes: BoxQuestionnaireQuestionOptionAttribute[];
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get imageAlt(): Nillable<string> {
    return this.data.imageAlt;
  }

  public get imageUrl(): Nillable<string> {
    return this.data.imageUrl;
  }

  public get isAvailable(): boolean {
    return this.data.isAvailable;
  }

  public get isSelected(): boolean {
    return this.data.isSelected;
  }

  public get isAutoSelected(): boolean {
    return valueOrDefault(this.data.isAutoSelected, false);
  }

  public get availableQuantity(): Nillable<number> {
    return this.data.availableQuantity;
  }

  public get remainingQuantity(): Nillable<number> {
    return this.data.remainingQuantity;
  }

  public get name(): string {
    return this.data.name;
  }

  public get sourceId(): Nillable<Guid> {
    return this.data.sourceId;
  }

  public get sourceName(): Nillable<string> {
    return this.data.sourceName;
  }

  public get attributes(): BoxQuestionnaireQuestionOptionAttribute[] {
    return this.data.attributes;
  }
}
